import {
  AvailabilityApi,
  DocumentApiFactory,
  DocumentSigningApiFactory,
  ElementTreeApi,
  EventsApiFactory,
  ImagesApiFactory,
  ObjectApiFactory,
  RuleEvaluatorApi,
  TokenApiFactory,
  UserApi,
  UserApiApiFactory,
  RequirementValidationResultsApiFactory,
} from "@radianse/services";
import axios from "axios";
import { TOKEN_NAME, SESSION, DEVICE_ID } from "../context/ApiAuthContext";

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function refreshAccessToken() {
  const deviceId = localStorage.getItem(DEVICE_ID);
  const session = localStorage.getItem(SESSION);
  const token = localStorage.getItem(TOKEN_NAME);
  // check if token expired
  const decodedToken = parseJwt(token);
  if (!token || decodedToken.exp < new Date().getTime() / 1000) {
    return TokenApiClient.getServiceClientToken("en-US,en", {
      clientId: deviceId,
      clientSecret: session,
    }).then((res) => {
      localStorage.setItem(TOKEN_NAME, res?.data?.token);
      return res?.data?.token;
    });
  }
  return token;
}
export const identity_instance = axios.create({
  baseURL: `${window["_env"].IDENTITY_API}`,
  headers: {
    Authorization: `Bearer ${localStorage.getItem(TOKEN_NAME)}`,
  },
});

// Request interceptor for API calls
identity_instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem(TOKEN_NAME);
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
identity_instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (
      (error?.response?.status === 401 || error?.response?.status === 403) &&
      !originalRequest?._retry
    ) {
      originalRequest._retry = true;
      const access_token = await refreshAccessToken();
      axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
      return identity_instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export const baseOptions = {
  timeout: 60000,
};
export const TokenApiClient = TokenApiFactory(
  {},
  `${window["_env"].IDENTITY_API}/identity`,
  identity_instance
);

export const objectApiClient = ObjectApiFactory(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/elements`,
  identity_instance
);

export const UserApiApiClient = UserApiApiFactory(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/users`,
  identity_instance
);
export const UserApiClient = new UserApi(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/users`,
  identity_instance
);

export const availApiClient = new AvailabilityApi(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/availability`,
  identity_instance
);

export const rulesApiClient = new RuleEvaluatorApi(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/rules`,
  identity_instance
);

export const RequirementValidationResultsApiClient =
  new RequirementValidationResultsApiFactory(
    { baseOptions },
    `${window["_env"].IDENTITY_API}/app/rules`,
    identity_instance
  );

export const elementTreeApiClient = new ElementTreeApi(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/elements`,
  identity_instance
);

export const eventsApiClient = EventsApiFactory(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/elements`,
  identity_instance
);
export const imagesApiClient = ImagesApiFactory(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/elements`,
  identity_instance
);

export const DocumentApiClient = DocumentApiFactory(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/documents`,
  identity_instance
);

export const DocumentSigningApiClient = DocumentSigningApiFactory(
  { baseOptions },
  `${window["_env"].IDENTITY_API}/app/documents`,
  identity_instance
);
